import { ToastType } from "@/types/toast";

// Define a type mapping ToastType to colors
export const ToastColors: Record<ToastType, string> = {
  [ToastType.Success]: "green",
  [ToastType.Error]: "red",
  [ToastType.Info]: "blue",
  [ToastType.Warning]: "orange",
};
